import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'wishlist',
  label: 'Wishlist Section',
  description: 'Displays saved/wishlisted products in a grid layout.',
  supportedPages: ['wishlist'],
  variants: [
    {
      id: 'v1',
      label: 'V1 (Grid)',
      fields: [
        { key: 'title', label: 'Page Title', type: 'string', default: 'My Wishlist' },
        { key: 'subtitle', label: 'Eyebrow Text', type: 'string', default: 'Saved items' },
        { key: 'emptyTitle', label: 'Empty State Title', type: 'string', default: 'Nothing saved yet' },
        { key: 'emptyText', label: 'Empty State Description', type: 'string', default: 'Start exploring and save the items you love.' },
        { key: 'continueShoppingText', label: 'CTA Text', type: 'string', default: 'Start Shopping' },
        { key: 'continueShoppingLink', label: 'CTA Link', type: 'string', default: '/shop' },
      ],
    },
  ],
  commonFields: [],
}
